import PropTypes from 'prop-types';
import { useState } from 'react';

import { useTownAssets } from '../../stores';
import { config } from '../../utils';
import { Button } from '../buttons';
import TextInput from '../input/TextInput';

import Column from './Column';
import FullPopup from './FullPopup';
import Row from './Row';

const WarnPopup = function WarnPopup(props) {
  const {
    contentClassName = 'h-full w-full min-h-36 relative overflow-hidden flex flex-col gap-2',
    className = 'min-w-[300px]',
    question,
    onConfirm,
    onReject,
    onClose,
    title,
    yes,
    no,
    children = null,
    confirmText,
    confirmDisabled,
    name,
    childrenBelowQuestion,
    confirmCritical,
  } = props;
  const { assets } = useTownAssets();
  const { translate } = assets;
  // Pre-fill answer in dev:
  const [txt, setTxt] = useState(config.dev ? confirmText : '');

  const invalid = confirmText && (confirmText !== txt);

  const onChange = (event) => {
    setTxt(event.currentTarget.value);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && (!invalid)) {
      onConfirm();
    }
  };

  return (
    <FullPopup
      title={title}
      contentClassName={contentClassName}
      onClose={onClose || onReject}
      small
      className={className}
      titleBar={!!title}
      name={name}
    >
      {(!childrenBelowQuestion) && children}

      <Column
        crossStart
        gap={2}
        className="flex-1"
      >
        {(question && (typeof question !== 'string'))

          ? question.map((thisQuestion, index) => <span key={`${index}`}>{thisQuestion}</span>)
          : <span className="overflow-y-auto my-auto">{question}</span>}
      </Column>

      {childrenBelowQuestion && children}

      {
        (confirmText)
          ? (
              <Column className="bg-pxUiAlertBg p-2 rounded-md">
                <span className="text-start">
                  {translate('pleaseTypeTxtToConfirm', 'statements', { txt: confirmText })}
                </span>

                <TextInput
                  value={txt}
                  onChange={onChange}
                  onKeyPress={handleKeyPress}
                  invalid={invalid}
                  className="bg-white"
                />
              </Column>
            )
          : null
      }

      {/* Stepping back is neutral, the move itself carries the base color, or the critical one when it destroys something */}
      <Row gap={6} evenly>
        <Button
          onClick={onReject}
          imgSrc="/images/svg/gui/cross.svg"
          label={no || translate('no')}
          neutralColor
        />

        <Button
          onClick={onConfirm}
          imgSrc="/images/svg/gui/check.svg"
          label={yes || translate('yes')}
          disabled={invalid || confirmDisabled}
          baseColor={!confirmCritical}
          criticalColor={!!confirmCritical}
        />
      </Row>
    </FullPopup>
  );
};

WarnPopup.propTypes = {
  contentClassName: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  question: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  yes: PropTypes.string,
  no: PropTypes.string,
  children: PropTypes.node,
  confirmText: PropTypes.string,
  confirmDisabled: PropTypes.bool,
  name: PropTypes.string,
  childrenBelowQuestion: PropTypes.bool,
  // Set when confirming deletes, erases or drops something: the confirm button turns critical
  confirmCritical: PropTypes.bool,
};

export default WarnPopup;
